import App from './App';
import { useAuth } from './hooks/useAuth';
import { PublicRoutes } from './routes/PublicRoutes';

const AppWrapper = () => {
    const { loggedIn } = useAuth();
    return (
        (loggedIn ? <App /> : <PublicRoutes />)
    );
};

export default AppWrapper;
